import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { APPLICATION_FLOW } from "@Shared/@Types/application/application-enums";
import { computed } from "@vue/composition-api";
export const useSubjectPropertyFieldVisibility = (options = {}) => {
  const {
    GET_CURRENT_FLOW
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_CURRENT_FLOW]);
  const {
    computeSchemaVisibility,
    computeTogglerVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const rootPath = "[property]";
  const existingMortgageIndex = computed(() => {
    var _options$existingMort, _options$existingMort2;
    return (_options$existingMort = (_options$existingMort2 = options.existingMortgageIndex) == null ? void 0 : _options$existingMort2.value) != null ? _options$existingMort : 0;
  });
  const existingMortgagePath = computed(() => rootPath + "[existing-mortgages]" + "[" + existingMortgageIndex.value + "]");
  const rootPathVisibilityPath = computed(() => {
    return _replaceAllInstanceProperty(rootPath).call(rootPath, /\[[[0-9]+\]/g, "");
  });
  const existingMortgageVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = existingMortgagePath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const propertyDetailsPurchasePriceVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][purchase-price]");
    const visibleFromFillOut = computeFillOutVisibility(APPLICATION_STEPS.GOALS, {
      path: rootPathVisibilityPath.value + "[details][purchase-price]"
    });
    return visibleFromSchema.value && visibleFromFillOut.value;
  });
  const propertyDetailsOccupancyVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][occupancy]");
    return visibleFromSchema.value;
  });
  const propertyDetailsPurchaseDateVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][purchase-date]");
    return visibleFromSchema.value;
  });
  const propertyDetailsLivingSpaceVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][living-space]");
    return visibleFromSchema.value;
  });
  const propertyDetailsAppraisedValueVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][appraised-value]");
    return visibleFromSchema.value;
  });
  const propertyDetailsAppraisalDateVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][appraisal-date]");
    return visibleFromSchema.value;
  });
  const propertyDetailsBlockVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][block]");
    return visibleFromSchema.value;
  });
  const propertyDetailsConcTownshipVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][conc-township]");
    return visibleFromSchema.value;
  });
  const propertyDetailsEstimatedValueVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][estimated-value]");
    return visibleFromSchema.value;
  });
  const propertyDetailsLotVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][lot]");
    return visibleFromSchema.value;
  });
  const propertyDetailsMlsListingVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][mls-listing]");
    return visibleFromSchema.value;
  });
  const propertyDetailsMonthlyIncomeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][monthly-income]");
    const visibleFromToggler = computeTogglerVisibility(rootPath + "[details][monthly-income]", [rootPath + "[details][rental-property]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const propertyDetailsPropertyValueIndexVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][property-value-index]");
    return visibleFromSchema.value;
  });
  const propertyDetailsRentalPropertyVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][rental-property]");
    return visibleFromSchema.value;
  });
  const propertyAddressVisibleFromSchemaAndFillOut = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[details][address]");
    const visibleFromFillOut = computeFillOutVisibility(APPLICATION_STEPS.GOALS, {
      path: rootPathVisibilityPath.value + "[details][address]"
    });
    return visibleFromSchema.value && visibleFromFillOut.value;
  });
  const propertyAddressVisible = computed(() => {
    const flowsWithPropertyAddress = [APPLICATION_FLOW.PURCHASE, APPLICATION_FLOW.REFINANCE, APPLICATION_FLOW.SWITCH_TRANSFER];
    return (!(GET_CURRENT_FLOW != null && GET_CURRENT_FLOW.value) || _includesInstanceProperty(flowsWithPropertyAddress).call(flowsWithPropertyAddress, GET_CURRENT_FLOW.value)) && propertyAddressVisibleFromSchemaAndFillOut.value;
  });
  const propertyAddressProvinceVisible = computed(() => {
    return (!(GET_CURRENT_FLOW != null && GET_CURRENT_FLOW.value) || GET_CURRENT_FLOW.value === APPLICATION_FLOW.PRE_APPROVAL) && propertyAddressVisibleFromSchemaAndFillOut.value;
  });
  const propertyStylePropertyStyleVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][property-style]");
    return visibleFromSchema.value;
  });
  const propertyStyleConstructionTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][construction-type]");
    return visibleFromSchema.value;
  });
  const propertyStyleEnvironmentalHazardVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][environmental-hazard]");
    return visibleFromSchema.value;
  });
  const propertyStyleHeatVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][heat]");
    return visibleFromSchema.value;
  });
  const propertyStyleLotSizeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][lot-size]");
    return visibleFromSchema.value;
  });
  const propertyStyleGarageStyleVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][garage-style]");
    const visibleFromToggler = computeTogglerVisibility(rootPath + "[styles][garage-style]", [rootPath + "[styles][garage-size]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const propertyStyleLotSizeTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][lot-size-type]");
    return visibleFromSchema.value;
  });
  const propertyStyleNumberOfUnitsVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][number-of-units]");
    return visibleFromSchema.value;
  });
  const propertyStyleSewageInfoVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][sewage-info]");
    return visibleFromSchema.value;
  });
  const propertyStyleStructureAgeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][structure-age]");
    const visibleFromToggler = computeTogglerVisibility(rootPath + "[styles][structure-age]", [rootPath + "[styles][construction-type]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const propertyStyleTenureVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][tenure]");
    return visibleFromSchema.value;
  });
  const propertyStyleWaterInfoVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][water-info]");
    return visibleFromSchema.value;
  });
  const propertyStylePropertyTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][property-type]");
    return visibleFromSchema.value;
  });
  const propertyStyleGarageSizeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[styles][garage-size]");
    return visibleFromSchema.value;
  });
  const propertyCostsFeesIncludeHeatVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][fees-include-heat]");
    return visibleFromSchema.value;
  });
  const propertyCostsHeatingVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][heating]");
    const visibleFromToggler = computeTogglerVisibility(rootPath + "[costs][heating]", [rootPath + "[costs][fees-include-heat]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const propertyCostsHydroVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][hydro]");
    return visibleFromSchema.value;
  });
  const propertyCostsIncludeInTdsVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][include-in-tds]");
    return visibleFromSchema.value;
  });
  const propertyCostsInsuranceVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][insurance]");
    return visibleFromSchema.value;
  });
  const propertyCostsInterestVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][interest]");
    return visibleFromSchema.value;
  });
  const propertyCostsMaintenanceFeesVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][maintenance-fees]");
    return visibleFromSchema.value;
  });
  const propertyCostsManagementVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][management]");
    return visibleFromSchema.value;
  });
  const propertyCostsOthersVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][others]");
    return visibleFromSchema.value;
  });
  const propertyCostsPercOfTotalMaintFeesVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][perc-of-total-maint-fees]");
    return visibleFromSchema.value;
  });
  const propertyCostsPropertyTaxesVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][property-taxes]");
    return visibleFromSchema.value;
  });
  const propertyCostsRentalIncomeOptionsVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][rental-income-options]");
    return visibleFromSchema.value;
  });
  const propertyCostsRentalIncomeOptionsPercentVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][rental-income-options-percent]");
    const visibleFromToggler = computeTogglerVisibility(rootPath + "[costs][rental-income-options-percent]", [rootPath + "[costs][rental-income-options]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const propertyCostsRepairsVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][repairs]");
    return visibleFromSchema.value;
  });
  const propertyCostsTaxResponsibleVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][tax-responsible]");
    return visibleFromSchema.value;
  });
  const propertyCostsTaxYearVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(rootPathVisibilityPath.value + "[costs][tax-year]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageBalanceRemainingVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[balance-remaining]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageBlendedAmortizationVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[blended-amortization]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageCurrentMortgageNumberVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[current-mortgage-number]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageFrequencyVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[frequency]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageInsuredVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[insured]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageInterestRateVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[interest-rate]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageLenderVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[lender]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageLoanTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[loan-type]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageMaturityDateVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[maturity-date]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageMortgageInsuranceProviderIdVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[mortgage-insurance-provider-id]");
    const visibleFromToggler = computeTogglerVisibility(existingMortgagePath.value + "[mortgage-insurance-provider-id]", [existingMortgagePath.value + "[insured]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const propertyExistingMortgageMortgageTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[mortgage-type]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageOrigAmountVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[orig-amount]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgagePaymentAmountVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[payment-amount]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgagePayoffVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[payoff]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageRateTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[rate-type]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageTermTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[term-type]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageRefiAdditionalInfoVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[refi-additional-info]");
    return visibleFromSchema.value;
  });
  const propertyExistingMortgageInsuranceAccountNumberVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[insurance-account-number]");
    const visibleFromToggler = computeTogglerVisibility(existingMortgagePath.value + "[insurance-account-number]", [existingMortgagePath.value + "[insured]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const existingMortgagesIsVisible = computed(() => {
    return propertyExistingMortgageBalanceRemainingVisible.value || propertyExistingMortgageBlendedAmortizationVisible.value || propertyExistingMortgageCurrentMortgageNumberVisible.value || propertyExistingMortgageFrequencyVisible.value || propertyExistingMortgageInsuredVisible.value || propertyExistingMortgageInterestRateVisible.value || propertyExistingMortgageLenderVisible.value || propertyExistingMortgageLoanTypeVisible.value || propertyExistingMortgageMaturityDateVisible.value || propertyExistingMortgageMortgageInsuranceProviderIdVisible.value || propertyExistingMortgageMortgageTypeVisible.value || propertyExistingMortgageOrigAmountVisible.value || propertyExistingMortgagePaymentAmountVisible.value || propertyExistingMortgagePayoffVisible.value || propertyExistingMortgageRateTypeVisible.value || propertyExistingMortgageTermTypeVisible.value || propertyExistingMortgageRefiAdditionalInfoVisible.value || propertyExistingMortgageInsuranceAccountNumberVisible.value;
  });
  return {
    propertyDetailsPurchasePriceVisible,
    propertyDetailsOccupancyVisible,
    propertyDetailsPurchaseDateVisible,
    propertyDetailsLivingSpaceVisible,
    propertyDetailsAppraisedValueVisible,
    propertyDetailsAppraisalDateVisible,
    propertyDetailsBlockVisible,
    propertyDetailsConcTownshipVisible,
    propertyDetailsEstimatedValueVisible,
    propertyDetailsLotVisible,
    propertyDetailsMlsListingVisible,
    propertyDetailsMonthlyIncomeVisible,
    propertyDetailsPropertyValueIndexVisible,
    propertyDetailsRentalPropertyVisible,
    propertyAddressVisible,
    propertyAddressProvinceVisible,
    propertyStylePropertyStyleVisible,
    propertyStyleConstructionTypeVisible,
    propertyStyleEnvironmentalHazardVisible,
    propertyStyleHeatVisible,
    propertyStyleLotSizeVisible,
    propertyStyleGarageStyleVisible,
    propertyStyleLotSizeTypeVisible,
    propertyStyleNumberOfUnitsVisible,
    propertyStyleSewageInfoVisible,
    propertyStyleStructureAgeVisible,
    propertyStyleTenureVisible,
    propertyStyleWaterInfoVisible,
    propertyStylePropertyTypeVisible,
    propertyStyleGarageSizeVisible,
    propertyCostsFeesIncludeHeatVisible,
    propertyCostsHeatingVisible,
    propertyCostsHydroVisible,
    propertyCostsIncludeInTdsVisible,
    propertyCostsInsuranceVisible,
    propertyCostsInterestVisible,
    propertyCostsMaintenanceFeesVisible,
    propertyCostsManagementVisible,
    propertyCostsOthersVisible,
    propertyCostsPercOfTotalMaintFeesVisible,
    propertyCostsPropertyTaxesVisible,
    propertyCostsRentalIncomeOptionsVisible,
    propertyCostsRentalIncomeOptionsPercentVisible,
    propertyCostsRepairsVisible,
    propertyCostsTaxResponsibleVisible,
    propertyCostsTaxYearVisible,
    propertyExistingMortgageBalanceRemainingVisible,
    propertyExistingMortgageBlendedAmortizationVisible,
    propertyExistingMortgageCurrentMortgageNumberVisible,
    propertyExistingMortgageFrequencyVisible,
    propertyExistingMortgageInsuredVisible,
    propertyExistingMortgageInterestRateVisible,
    propertyExistingMortgageLenderVisible,
    propertyExistingMortgageLoanTypeVisible,
    propertyExistingMortgageMaturityDateVisible,
    propertyExistingMortgageMortgageInsuranceProviderIdVisible,
    propertyExistingMortgageMortgageTypeVisible,
    propertyExistingMortgageOrigAmountVisible,
    propertyExistingMortgagePaymentAmountVisible,
    propertyExistingMortgagePayoffVisible,
    propertyExistingMortgageRateTypeVisible,
    propertyExistingMortgageTermTypeVisible,
    propertyExistingMortgageRefiAdditionalInfoVisible,
    propertyExistingMortgageInsuranceAccountNumberVisible,
    existingMortgagesIsVisible
  };
};